import {push} from 'react-router-redux';

import api from 'utils/api';
import {USER_LANG} from 'utils/locale';

// Actions
const SET_WORKER = 'WORKERS/SET_WORKER';
const SET_PIN_CODE = 'WORKERS/SET_PIN_CODE';
const SET_ERROR = 'WORKERS/SET_ERROR';

// Initial state for reducer
const initialState = {
    worker: null,
    pinCode: null,
    error: null,
    token: null,
};

// Reducer(s)
export default function workerReducer(state = initialState, action) {
    switch (action.type) {
        case SET_WORKER:
            return {...state, worker: action.worker, token: action.token, error: null};
        case SET_PIN_CODE:
            return {...state, pinCode: action.pinCode};
        case SET_ERROR:
            return {...state, error: action.error};
        default:
            return state;
    }
}

// Action creators
const setWorker = (worker, token) => ({type: SET_WORKER, worker, token});
const setPinCode = pinCode => ({type: SET_PIN_CODE, pinCode});
const setError = error => ({type: SET_ERROR, error});

export const updateWorker = pinCode => (dispatch) => {
    dispatch(setPinCode(pinCode));

    api.accountsWorkerAuth.post(null, {pin_code: pinCode}).then(
        (data) => {
            const currentConfig = api.config();
            const config = {
                ...currentConfig,
                headers: {
                    ...currentConfig.headers,
                    Authorization: `Token ${data.token}`,
                },
            };
            api.setConfig(config);

            dispatch(setWorker(data.worker, data.token));
            dispatch(push(`/${USER_LANG}/production`));
        },
        (error) => {
            let message = gettext("Authentication failed");
            if (error.statusCode === 403) {
                try {
                    message = JSON.parse(error.responseText).detail;
                } catch (e) {
                    // Display the default message
                }
            }
            dispatch(setError(message));
        },
    );
};



// WEBPACK FOOTER //
// ./src/ducks/workers.js